import React, { useContext } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Button,
  useId,
} from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import type { EndLiveAgentDialogProps } from './types';

export const EndLiveAgentDialog = ({
  open, setOpen, onConfirm,
}: EndLiveAgentDialogProps) => {
  const i18n = useContext(I18nContext) as I18nModel;

  const dialogId = useId('dialog-');

  return (
    <Dialog
      open={open}
      onOpenChange={(_e, data) => {
          setOpen(data.open);
        }}
    >
      <DialogSurface
        aria-labelledby={`${dialogId}-title`}
        aria-describedby={`${dialogId}-content`}
      >
        <DialogBody>
          <DialogTitle id={`${dialogId}-title`}>
            {i18n.getString(_TL_('Are you sure you want to proceed?'))}
          </DialogTitle>
          <DialogContent id={`${dialogId}-content`}>
            {i18n.getString(_TL_('This will end your live chat.'))}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="primary" onClick={onConfirm}>{i18n.getString(_TL_('Yes'))}</Button>
            </DialogTrigger>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">{i18n.getString(_TL_('No'))}</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
